<template>
  <section>
    <div style="padding-left: 20px;">
      <ProjectList @proSelected="proChange"></ProjectList>
    </div>
    <el-row>
      <el-col :span="8">
        <div class="tabCBox">
          <div class="c-box">
            <div class="title"><i></i>工程简介</div>
            <table cellspacing="1">
              <tr>
                <td>建筑面积</td>
                <td>{{this.abstractData.proTab1}}</td>
              </tr>
              <tr>
                <td>结构形式</td>
                <td>{{this.abstractData.proTab2}}</td>
              </tr>
              <tr>
                <td>总层数</td>
                <td>{{this.abstractData.proTab3}}</td>
              </tr>
              <tr>
                <td>建设单位</td>
                <td>{{this.abstractData.proTab4}}</td>
              </tr>
              <tr>
                <td>监理单位</td>
                <td>{{this.abstractData.proTab5}}</td>
              </tr>
              <tr>
                <td>安质监站</td>
                <td>{{this.abstractData.proTab6}}</td>
              </tr>
              <tr>
                <td>总承建单位</td>
                <td>{{this.abstractData.proTab7}}</td>
              </tr>
            </table>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="tabCBox">
          <div class="c-box">
            <div class="title"><i></i>项目效果展示</div>
            <el-carousel indicator-position="outside" v-if="abstractData.proPhoto!=null" :interval="5000"
                         height="260px">
              <el-carousel-item v-for="(item,index) in abstractData.proPhoto==null?'': abstractData.proPhoto.split(',')"
                                :key="index">
                <img :src="GLOBAL.basePhotoPath+item" width="100%" height="100%"/>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="tabCBox">
          <div class="c-box">
            <div class="title"><i></i>工程动态</div>
            <ul class="message">
              <li v-for="(item,index) in dynamicData">
                <div class="layout-left"><a class="meslink" href="javascript:void(0)" @click="openMes(item.id)">{{item.mesTitle}}</a>
                </div>
                <div class="layout-right">{{item.updateTime | formatFDate}}</div>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <div class="tabCBox">
          <div class="c-box">
            <div class="title"><i></i>环境监测</div>
            <div id="chartLine" style="width: 100%; height: 270px;"></div>
            <div class="linetab">
              <div class="layout-left"><img src="../../assets/img/ic_weather.png" class="tabicon"></div>
              <div class="layout-left">
                <p class="tabtext">天气</p>
                <p class="tabdesc">{{this.environmentData.weather}}</p>
              </div>
              <div class="layout-left"><img src="../../assets/img/ic_pm.png" class="tabicon"></div>
              <div class="layout-left">
                <p class="tabtext">PM2.5/PM10</p>
                <p class="tabdesc">{{this.environmentData.pm2d5}}/{{this.environmentData.pm10}}ug/m3</p>
              </div>
              <div class="layout-left"><img src="../../assets/img/ic_noice.png" class="tabicon"></div>
              <div class="layout-left">
                <p class="tabtext">噪声</p>
                <p class="tabdesc">{{this.environmentData.noise}}db</p>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="tabCBox">
          <div class="c-box">
            <div class="title"><i></i>劳动力情况</div>
            <div id="chartColumn" style="width: 100%; height: 300px;"></div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="tabCBox" style="overflow-y: scroll">
          <div class="c-box">
            <div class="title" style="width: 100%"><i></i>安全数据</div>
            <el-row class="safebox" v-for="(item,index) in safeData" :key="index">
              <el-col :span="4" class="safemes">
                <div>{{item.name}}</div>
                <div><img src="../../assets/img/ic_tadiao.png"></div>
              </el-col>
              <el-col :span="10" class="safemes">
                <div class="c-box-m">
                  <ul>
                    <li class="safelabel">高度</li>
                    <li class="space">{{item.height}}</li>
                    <li>米</li>
                  </ul>
                  <ul>
                    <li class="safelabel">重量</li>
                    <li class="space">{{item.weight}}</li>
                    <li>吨</li>
                  </ul>
                  <ul>
                    <li class="safelabel">中心距</li>
                    <li class="space">{{item.cenSpacing}}</li>
                    <li>米</li>
                  </ul>
                  <ul>
                    <li class="safelabel">力距</li>
                    <li class="space">{{item.momentForce}}</li>
                    <li>吨/米</li>
                  </ul>
                  <ul>
                    <li class="safelabel">风力</li>
                    <li class="space">{{item.windForce}}</li>
                    <li>级</li>
                  </ul>
                  <ul>
                    <li class="safelabel">倾斜</li>
                    <li class="space">{{item.lean}}</li>
                    <li>mm</li>
                  </ul>
                </div>
              </el-col>
              <el-col :span="10" class="safemes" style="height:125px;">
                <span style="float: right" class="title">违规操作<i style="background: #efefef;text-align: center;">{{item.momentForceAlertTimes}}</i>次</span>
                <div id="safeview1" style="width:100%;height: 235px; margin-top: -50px;"></div>
              </el-col>
            </el-row>

          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 详情界面 -->
    <el-dialog :title="formData.mesTitle" :visible.sync="detailsVisible" :modal="false" class="details"
               :close-on-click-modal="false">
      <MessageView :mes="formData.mesContent"></MessageView>
    </el-dialog>
  </section>
</template>

<script>
  import echarts from 'echarts'
  import {
    abstract,
    dynamic,
    environment,
    members,
    safe,
    proDetail,
    mesSearch,
    mesDetail,
    proSearch
  } from '../../api/api'
  import MessageView from "../message/MessageView";
  import ProjectList from "../command/ProjectList";

  app.config = {
    rotate: 0,
    align: 'center',
    verticalAlign: 'bottom',
    position: 'top',
    distance: 0,

  };
  let labelOption = {
    normal: {
      show: true,
      position: app.config.position,
      distance: app.config.distance,
      align: app.config.align,
      verticalAlign: app.config.verticalAlign,
      rotate: app.config.rotate,
      formatter: '{c}',
      fontSize: 16,
      rich: {
        name: {
          textBorderColor: '#fff'
        }
      }
    }
  };
  export default {
    components: {ProjectList, MessageView},
    data() {
      return {
        chartLine: null,
        safechart: null,
        abstractData: {},
        dynamicData: [],
        environmentData: {},
        membersData: {workerTypes: []},
        safeData: [],
        proId: null,
        detailsVisible: false,
        formData: {},
        proList: [],
      }
    },

    methods: {
      // drawSafeView1Chart() {
      //   this.safechart = echarts.init(document.getElementById('safeview1'));
      //   this.safechart.setOption({
      //
      //     color: ['#c8ffd6'],
      //     grid: {
      //       left: '3%',
      //       containLabel: true
      //     },
      //     xAxis: {
      //       type: 'category',
      //       boundaryGap: false,
      //       data: ['Mon', 'Tue', 'Wed']
      //     },
      //     yAxis: {
      //       type: 'value'
      //     },
      //     series: [{
      //       data: [820, 932, 901],
      //       type: 'line',
      //       areaStyle: {normal:{}}
      //     }]
      //   });
      // },
      // drawSafeView2Chart() {
      //   this.safechart = echarts.init(document.getElementById('safeview2'));
      //   this.safechart.setOption({
      //
      //     color: ['#c8ffd6'],
      //     grid: {
      //       left: '3%',
      //       containLabel: true
      //     },
      //     xAxis: {
      //       type: 'category',
      //       boundaryGap: false,
      //       data: ['Mon', 'Tue', 'Wed']
      //     },
      //     yAxis: {
      //       type: 'value'
      //     },
      //     series: [{
      //       data: [820, 932, 901],
      //       type: 'line',
      //       areaStyle: {normal:{}}
      //     }]
      //   });
      // },
      drawLineChart() {
        this.chartLine = echarts.init(document.getElementById('chartLine'));
        this.chartLine.setOption({
          color: ['#30CF53', '#F6751B'],
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            left: 'left',
            data: ['PMC2.5', 'PM10']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.environmentData.timeAxis
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'PMC2.5',
              type: 'line',
              data: this.environmentData.pm2d5Curve
            },
            {
              name: 'PM10',
              type: 'line',
              data: this.environmentData.pm10Curve
            }
          ]
        });
      },
      drawColumnChart() {
        this.chartColumn = echarts.init(document.getElementById('chartColumn'));
        this.chartColumn.setOption({
          color: ['#30CF53', '#F6751B'],

          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            left: 'right',
            data: ['应到人数', '实到人数']
          },
          toolbox: {
            show: false,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: true},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          xAxis: {
            data: this.membersData.workerTypes
          },
          yAxis: {},
          series: [
            {
              name: '应到人数',
              type: 'bar',
              label: labelOption,
              data: this.membersData.objNums
            },
            {
              name: '实到人数',
              type: 'bar',
              label: labelOption,
              data: this.membersData.actualNums
            }
          ]
        });
      },
      drawCharts() {
        this.drawColumnChart()
        // this.drawSafeView1Chart();
        this.drawLineChart();
        // this.drawSafeView2Chart();
      },
      openMes: function (id) {
        mesDetail({id: id}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.formData = result.data;
            this.detailsVisible = true;
          }
        });
      },
      proChange: function (proId) {
        this.proId = proId;
        proDetail({id: this.proId}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.abstractData = result.data;
          }
        });
        mesSearch({
          page: 1,
          limit: 8,
          proId: this.proId == '' ? null : this.proId,
          comId: this.GLOBAL.user.comId
        }, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.dynamicData = result.data.result;
          }
        });
        //环境监测
        environment({projectId: this.proId}, this.GLOBAL.header).then(result => {
          if (result.data.res == 'SUCCESS') {
            this.environmentData = result.data.data;
          }

        });
        //劳动力情况
        members({projectId: this.proId}, this.GLOBAL.header).then(result => {
          if (result.data.res == 'SUCCESS') {
            this.membersData = result.data.data;
          }

        });
        //安全
        safe({projectId: this.proId}, this.GLOBAL.header).then(result => {
          if (result.data.res == 'SUCCESS') {
            this.safeData = result.data.data;
          }

        });

      },
    },
    filters: {
      formatFDate: function (date) {
        let d = new Date(date).Format("yyyy-MM-dd");
        return d.toLocaleString();
      },
    },
    mounted: function () {

    },
    updated: function () {
      this.drawCharts()
    }
  }
</script>

<style scoped>
  .meslink {
    text-decoration: none;
    color: blue;
  }

  .el-col {
    padding: 30px 20px;
  }

  .tabCBox {
    position: relative;
    border: 1px solid #c0c7d1;
    width: 100%;
    height: 350px;
    box-shadow: darkgrey 0px 0px 2px 0px;
  }

  .tabCBox table {
    width: 100%;
    background: #dbdbdb;
  }

  .tabCBox tr {
    background: #f7f7f7;
    height: 35px;
  }

  .tabCBox tr {
    text-indent: 3em;
  }

  .proshow {
    width: 100%;
    border-radius: 0px;
    margin: 0px;
    height: 255px;
  }

  .message {
    padding-left: 20px;
  }

  .message li {
    list-style-type: disc;
    height: 35px;
    line-height: 35px;
    color: #3E7D27;
  }

  .message li div {
    color: #000
  }

  .linetab {
    position: absolute;
    top: 16px;
    right: 0px;
    width: 300px;
    height: 40px;
  }

  .tabicon {
    margin: 0px;
  }

  .linetab p {
    margin: 0px;
    padding: 1px 7px 1px 7px;
    font-family: 新宋体;
    color: #6c6c6c
  }

  .tabdesc {
    color: #8c939d;
    font-size: 12px;
    padding: 5px;
  }

  .safebox {
    position: relative;
    width: 100%;
    height: 135px;
  }

  .safetitle {
    font-size: 16px;
    font-weight: bold;
  }

  .safemes {
    font-family: 宋体;
    padding: 0;
    margin: 0;
  }

  .safemes li {
    list-style-type: none;
    float: left;
    margin-bottom: 5px;
  }

  .safemes .safelabel {
    text-align: right;
    width: 50px;
  }

  .safemes .space {
    background: #dae2ec;
    width: 50px;
    text-align: center;
    margin: 0 5px 0 5px
  }

  .linetab img {
    width: 20px;
    height: 20px;
    border-radius: 20px;
  }

  .safebox img {
    width: 30px;
    height: 30px;
    border-radius: 20px;
  }

  .c-box {
    width: 90%;
    margin: auto;
  }

  .c-box-m {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/overview/Overview.vue